import React from 'react';
import { useFormik } from "formik";
import * as yup from "yup";
import { useAuth } from "../../provider/authProvider";
import { useNavigate } from 'react-router-dom';
// Removed useSignalRContext import - connect() is automatic via SignalRProvider
import { Login, GetUser } from "../../api/auth";
import { toast } from "react-toastify";
import './index.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const validation = yup.object({
    email: yup.string().email("Enter a valid email").required("Email is required"),
    password: yup.string().min(6, "Password should have a minimum of 6 characters").required("Password is required"),
  });
  const { handleSubmit, handleChange, handleBlur, values, touched, errors } = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: validation,
    onSubmit: async (values) => {
      try {
        const { token, user, error } = await Login(values.email, values.password);
        
        if (token === null) {
          console.error("Login failed:", error);
          toast.error(typeof error === 'string' ? error : 'Login failed');
        } else {
          setToken(token);
          
          // Check if user data is already provided in login response
          if (user && user.id && user.email) {
            localStorage.setItem('user', JSON.stringify(user));
          } else {
            // Try to decode user data from JWT token
            try {
              if (token && token.includes('.') && token.split('.').length === 3) {
                const payload = JSON.parse(atob(token.split('.')[1]));
                
                const userData = {
                  id: payload.userId || payload.id,
                  email: payload.email,
                  firstName: payload.firstName,
                  lastName: payload.lastName,
                  role: payload.role,
                  permissions: payload.permission || payload.permissions || [],
                  permissionCount: payload.permissionCount
                };
                
                localStorage.setItem('user', JSON.stringify(userData));
              } else {
                // Fallback: fetch complete user data from API
                const userData = await GetUser(token, values.email);
                localStorage.setItem('user', JSON.stringify(userData));
              }
            } catch (userError) {
              console.error("Error getting user data:", userError);
              // Continue with login even if user data fetch fails
            }
          }

          // CRITICAL FIX: Removed connect(token) call
          // SignalRProvider automatically connects when token changes
          // Calling connect() here was creating DOUBLE connections
          navigate("/dashboard", { replace: true });
        }
      } catch (error) {
        console.error("Login network error:", error);
        
        // Check for JWT configuration error
        if (error.response?.data?.message?.includes('IDX10653') || 
            error.response?.data?.message?.includes('encryption algorithm')) {
          toast.error("Server configuration error. Please contact administrator.");
        } else {
          toast.error("Network Error: Unable to connect to server");
        }
      }
    },
  });
  return (
    <div className="auth-root">
      <div className="auth-left">
        <form className="auth-form" onSubmit={handleSubmit}>
          <h2 className="auth-title">Sign in</h2>
          <label className="auth-label" htmlFor="email">Email <span>*</span></label>
          <input
            className="auth-input"
            id="email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="email"
          />
          {touched.email && errors.email && <div className="auth-error">{errors.email}</div>}
          <label className="auth-label" htmlFor="password">Password <span>*</span></label>
          <input
            className="auth-input"
            id="password"
            name="password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="current-password"
          />
          {touched.password && errors.password && <div className="auth-error">{errors.password}</div>}
          <button className="auth-btn" type="submit">Login</button>
          {/* <button type="button" className="google-btn" style={{marginTop:16, background:'#4285F4', color:'#fff', border:'none', borderRadius:4, padding:0, fontWeight:500, display:'flex', alignItems:'center', justifyContent:'center', height:40, width:'100%', fontSize:16, cursor:'pointer', boxShadow:'0 1px 2px rgba(60,64,67,.3)'}}>
            <span style={{background:'#fff', height:40, width:40, display:'flex', alignItems:'center', justifyContent:'center', borderTopLeftRadius:4, borderBottomLeftRadius:4, marginRight:12}}>
              <svg width="18" height="18" viewBox="0 0 18 18"><g><path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.56-2.5C13.73.89 11.7 0 9 0 5.48 0 2.44 2.24 1 5.5l3.04 2.36C4.88 5.36 6.75 3.48 9 3.48z" fill="#EA4335"/><path d="M17.64 9.2c0-.63-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.13-.84 2.09-1.8 2.73l2.82 2.2c1.65-1.53 2.6-3.78 2.6-6.57z" fill="#4285F4"/><path d="M3.91 10.96A5.41 5.41 0 0 1 3.5 9c0-.68.12-1.34.32-1.96L.78 4.62A8.97 8.97 0 0 0 0 9c0 1.41.34 2.75.94 3.93l2.97-2.97z" fill="#FBBC05"/><path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.82-2.2c-.78.52-1.78.83-3.14.83-2.25 0-4.12-1.88-4.79-4.39l-3.04 2.36C2.44 15.76 5.48 18 9 18z" fill="#34A853"/></g></svg>
            </span>
            <span style={{flex:1, textAlign:'center'}}>Sign in with Google</span>
          </button>
          <div className="auth-link-row">
            <span>Don't have an account?</span>
            <button type="button" className="auth-link" onClick={() => navigate('/register')}>Create an account</button>
          </div> */}
        </form>
      </div>
      <div className="auth-right">
        <div className="auth-logo-row">
          {/* <span className="rocket-emoji">🚀</span> */}
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', height: '100%', gap: '6px' }}>
              <span className="brand-title-row" style={{ fontWeight: 900, fontSize: 44, color: '#3deaff', letterSpacing: 0.5, lineHeight: 1, display: 'block' }}>
                  Q<span style={{ fontWeight: 700, fontSize: 45, color: '#3deaff', marginLeft: 0 }}>TradeView</span>
              </span>
              <span style={{ fontSize: 12, color: '#8b9cb5', fontWeight: 600, letterSpacing: '0.5px', display: 'flex', alignItems: 'center', lineHeight: 1 }}>
                  ArbX Intelligence
              </span>
          </div>
        </div>
        <div className="auth-marketing-center">
          <div className="auth-marketing">
            <h1 className="auth-marketing-title">Bring trading to <span className="auth-gradient">life</span></h1>
            <div className="auth-hashtag">#withQTradeView</div>
            <div className="auth-marketing-desc">
              From market analysis and algorithmic strategies to execution and portfolio management, build and automate anything in one powerful professional platform.
            </div>
            <div className="auth-marketing-trust">Trusted by 500,000+ Traders &nbsp; | &nbsp; Ultra-low latency</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;